
export const BombWebsiteName = "https://www.bomb.money/";
export const BombFarmWebsiteName = "https://app.bomb.money/";
export const DashboardPageName = "/dashboard";
